import {
    DEFAULT_CURRENCY,
    SETTLEMENT_STATUS,
} from '../../../utils/constants/commonValues';
import moment from 'moment';

function SettlementStatusData(data) {
    if (data.transactionViewList) {
        this.tableData = this.createTableData(data);
        this.pagination = this.createPaginationData(data);
    }
    if (data.dailySettlementMetrics) {
        this.dailySettlementMetrics = this.createMetrics(data);
    }
}
SettlementStatusData.prototype = Object.assign(SettlementStatusData.prototype, {
    createTableData(tableData) {
        return (
            tableData &&
            tableData.transactionViewList &&
            tableData.transactionViewList.map(row => this.createRow(row))
        );
    },
    createPaginationData(data) {
        if (data) {
            const { pageNo, totalElements } = data;
            return {
                hasNextPage: false,
                hasPreviousPage: false,
                pageNumber: pageNo,
                pageSize: 10,
                sortingCriteria: '',
                totalNumberOfPages: 0,
                totalNumberOfRecords: totalElements,
            };
        }
        return {};
    },
    createRow(row) {
        const {
            date,
            entityName,
            utr,
            settlementStatus,
            settlementId,
            settlementMetrics,
            remarks,
        } = row;
        return {
            date: this.convertDate(date),
            entityName,
            utr,
            settlementStatus: this.getStatus(settlementStatus),
            settlementId,
            netSettlementAmount:
                settlementMetrics && settlementMetrics.netSettlementAmount
                    ? `${DEFAULT_CURRENCY} ${settlementMetrics.netSettlementAmount}`
                    : '-',
            grossAmt:
                settlementMetrics && settlementMetrics.grossAmt
                    ? `${DEFAULT_CURRENCY} ${settlementMetrics.grossAmt}`
                    : '-',
            refundAmt:
                settlementMetrics && settlementMetrics.refundAmt
                    ? `${DEFAULT_CURRENCY} ${settlementMetrics.refundAmt}`
                    : '-',
            fee:
                settlementMetrics && settlementMetrics.fee
                    ? `${DEFAULT_CURRENCY} ${settlementMetrics.fee}`
                    : '-',
            gst:
                settlementMetrics && settlementMetrics.gst
                    ? `${DEFAULT_CURRENCY} ${settlementMetrics.gst}`
                    : '-',
            originalData: row,
            comments: remarks && remarks.length > 0 ? remarks : [],
        };
    },
    convertDate(timeStamp) {
        const dateString = moment(timeStamp).format('DD/MM/YYYY hh:mm a');
        return dateString;
    },

    getStatus(status) {
        if (status && SETTLEMENT_STATUS[status]) {
            return SETTLEMENT_STATUS[status];
        }

        return status;
    },
    createMetrics(data) {
        const { dailySettlementMetrics = {} } = data || {};
        return {
            grossAmt: dailySettlementMetrics.grossAmt
                ? `${DEFAULT_CURRENCY} ${dailySettlementMetrics.grossAmt}`
                : '-',
            refundAmt: dailySettlementMetrics.refundAmt
                ? `${DEFAULT_CURRENCY} ${dailySettlementMetrics.refundAmt}`
                : '-',
            fee: dailySettlementMetrics.fee
                ? `${DEFAULT_CURRENCY} ${dailySettlementMetrics.fee}`
                : '-',
            gst: dailySettlementMetrics.gst
                ? `${DEFAULT_CURRENCY} ${dailySettlementMetrics.gst}`
                : '-',
            netSettlementAmount: dailySettlementMetrics.netSettlementAmount
                ? `${DEFAULT_CURRENCY} ${dailySettlementMetrics.netSettlementAmount}`
                : '-',
        };
    },
});

export default SettlementStatusData;
